var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 320 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 15C64 6.71573 70.7157 0 79 0H225C233.284 0 240 6.71573 240 15C240 23.2843 233.284 30 225 30H213.5C205.312 30 198.675 36.2678 198.675 44C198.675 51.7322 205.312 58 213.5 58H305C313.284 58 320 64.7157 320 73C320 81.2843 313.284 88 305 88H117.5C109.312 88 102.675 94.2678 102.675 102C102.675 109.732 109.312 116 117.5 116H193C201.284 116 208 122.716 208 131C208 139.284 201.284 146 193 146H33C24.7157 146 18 139.284 18 131C18 122.716 24.7157 116 33 116H63C71.1876 116 77.825 109.732 77.825 102C77.825 94.2678 71.1876 88 63 88H15C6.71573 88 0 81.2843 0 73C0 64.7157 6.71573 58 15 58H159C167.188 58 173.825 51.7322 173.825 44C173.825 36.2678 167.188 30 159 30H79C70.7157 30 64 23.2843 64 15Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud3);
export default __webpack_public_path__ + "static/media/cloud_3.ce60c5a31bcb92d616fbe48d832839e9.svg";
export { ForwardRef as ReactComponent };